import React from 'react';
import { Link } from 'react-router-dom';
import { ReportPanel, money, number } from './ReportPanel';
import { useReport } from '../../hooks/useDashboardReports';
import { paths } from '../../routes/paths';

/**
 * Confirmed + verified sales grouped by bank account ("cuenta de destino"), all raffles, all time.
 * Hidden when there are no accounts configured and no sales to show.
 */
export default function CuentaSalesReport({ currency }) {
  const report = useReport('/api/cuentas/report');
  const rows = Array.isArray(report.data?.rows) ? report.data.rows : [];
  if (report.state !== 'ready' || rows.length === 0) return null;
  const totals = report.data.totals || {};

  return (
    <ReportPanel
      title='Ventas por cuenta de destino'
      description='Reservas confirmadas y verificadas de todos los bonos, agrupadas por la cuenta que recibe el dinero.'
      action={
        <Link
          to={paths.admin.config}
          className='text-sm font-medium text-primary no-underline hover:underline'
        >
          Gestionar cuentas
        </Link>
      }
    >
      <div className='overflow-x-auto'>
        <table className='w-full text-sm'>
          <thead>
            <tr className='border-b border-border text-left text-xs text-muted-foreground'>
              <th className='py-2 pr-3 font-medium'>Cuenta</th>
              <th className='py-2 pr-3 text-right font-medium'>Ventas</th>
              <th className='py-2 text-right font-medium'>Monto</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.cuentaId || 'none'} className='border-b border-border last:border-0'>
                <td className='py-2.5 pr-3'>
                  <span className='font-medium text-foreground'>{row.nombre}</span>
                  {row.beneficiario && row.beneficiario !== row.nombre && (
                    <span className='block text-xs text-muted-foreground'>{row.beneficiario}</span>
                  )}
                  {!row.activa && (
                    <span className='text-xs text-muted-foreground'> (inactiva)</span>
                  )}
                </td>
                <td className='py-2.5 pr-3 text-right tabular-nums'>{number(row.count)}</td>
                <td className='py-2.5 text-right tabular-nums'>{money(row.total, currency)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className='font-semibold'>
              <td className='pt-3 pr-3'>Total</td>
              <td className='pt-3 pr-3 text-right tabular-nums'>{number(totals.count)}</td>
              <td className='pt-3 text-right tabular-nums'>{money(totals.total, currency)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </ReportPanel>
  );
}
